export function createPathPoints(river, w) {
  const points = river.x.map((x, i) => [x, river.y[i]]);

  const channels = [
    { l: [], r: [] }, // top channel
    { l: [], r: [] }, // bottom channel
    [], // islands
  ];

  const widths = points.map(([x, y]) => {
    const top = window.terrain.width(x, y);
    const bottom = window.terrain.width(x - 20, y);
    return { top, bottom, total: top + bottom };
  });

  const splitAt = 8;
  const minGap = 0.4;
  const maxGap = 1.5;
  let gaps = widths.map((w, i) => {
    const [x, y] = points[i];
    // Terrain noise is deterministic per world position — no frame-to-frame flicker
    const n = window.terrain.noise2D(x / 400 + 100, y / 400 + 100);
    if (n > 0.2) {
      const gap = Math.min(maxGap, w.total - splitAt);
      if (gap < minGap) return 0;
      return gap;
    }
    return 0;
  });

  const N = 3;
  // Precompute sequence boundaries in a single pass
  const seqStart = new Array(gaps.length);
  const seqEnd = new Array(gaps.length);
  let runStart = -1;
  for (let i = 0; i < gaps.length; i++) {
    if (gaps[i] >= minGap) {
      if (runStart === -1) runStart = i;
    } else {
      if (runStart !== -1) {
        for (let j = runStart; j < i; j++) {
          seqStart[j] = runStart;
          seqEnd[j] = i - 1;
        }
        runStart = -1;
      }
    }
  }
  if (runStart !== -1) {
    for (let j = runStart; j < gaps.length; j++) {
      seqStart[j] = runStart;
      seqEnd[j] = gaps.length - 1;
    }
  }

  gaps = gaps.map((gap, i) => {
    if (i < N || i >= gaps.length - N) return 0;
    if (gap < minGap) return 0;

    // Find the start and end of the continuous sequence first
    const start = seqStart[i];
    const end = seqEnd[i];

    // Check if sequence is long enough
    if (end - start + 1 < N * 2) return 0;

    // Calculate position within the sequence (0 to 1)
    const position = (i - start) / (end - start);

    // Create almond shape using sine function
    // const almondShape = Math.sin(Math.PI * position) * gap;

    // More pointed almond (using power function)
    // const almondShape = Math.pow(Math.sin(Math.PI * position), 0.7) * gap;

    // Wider middle (using cosine)
    // const almondShape = ((1 - Math.cos(Math.PI * position)) * gap) / 2;

    // Asymmetric almond (shifts the peak)
    // const almondShape = Math.sin(Math.PI * Math.pow(position, 1.2)) * gap;

    const teardropShape = Math.sin(Math.PI * Math.pow(position, 0.7)) * gap;

    return teardropShape;
  });

  const islands = [];
  let island = { r: [], l: [] };
  for (let i = 0; i < points.length; i++) {
    const current = points[i];

    // Calculate direction vectors
    // maybe we should do this after modifying the NEXT point and use the updated current
    let dx, dy;
    if (i === points.length - 1) {
      const prev = points[i - 1];
      dx = current[0] - prev[0];
      dy = current[1] - prev[1];
    } else {
      const next = points[i + 1];
      dx = next[0] - current[0];
      dy = next[1] - current[1];
    }

    const len = Math.sqrt(dx * dx + dy * dy);
    const nx = -dy / len;
    const ny = dx / len;

    const { top, bottom, total } = widths[i];

    if (river.w) river.w[i] = total;

    let gap = gaps[i];
    if (gap <= 0) {
      if (island.l.length > 0) {
        islands.push(island);
        island = { r: [], l: [] };
      }
    }

    // Top channel -- centerline to terrain
    channels[0].l.push({
      gap: gap,
      x: current[0] - nx * gap * 0,
      y: current[1] - ny * gap * 0,
    });
    channels[0].r.push({
      gap: 1,
      x: current[0] - nx * top - gap,
      y: current[1] - ny * top - gap,
    });

    // Bottom channel -- terrain to centerline
    channels[1].l.push({
      gap: 1,
      x: current[0] + nx * bottom + gap,
      y: current[1] + ny * bottom + gap,
    });
    channels[1].r.push({
      gap: gap,
      x: current[0] + nx * gap * 0,
      y: current[1] + ny * gap * 0,
    });

    if (river.g) {
      river.g[i] = gap / maxGap;
    }
    if (gap > 0) {
      // Islands -- centerline to centerline
      island.l.push({
        gap: gap,
        x: current[0] - nx * gap,
        y: current[1] - ny * gap,
      });
      island.r.push({
        gap: gap,
        x: current[0] + nx * gap,
        y: current[1] + ny * gap,
      });
    }
  }
  channels[2] = islands;

  // Convert channels into closed paths
  return channels.map((channel, i) => {
    if (i === 2) return channel.map((c) => flattenChannel(c));
    return flattenChannel(channel);
  });
}

function flattenChannel(channel) {
  const rightSideReversed = [...channel.r].reverse();
  const fullPath = [...channel.l, ...rightSideReversed];
  fullPath.push(fullPath[0]); // Close the path
  return fullPath;
}
